import { z } from 'zod';
import { toDateInputValue } from '@/shared/utils/date-input';

/**
 * A required `<input type="date">` field: present, and a date we can parse.
 *
 * Without this, an unparseable value was only ever reported through the
 * "end after start" comparison — `new Date('garbage')` is `NaN`, and `NaN > NaN`
 * is false — so the form blamed the ordering for a value that simply isn't a
 * date.
 *
 * Note this field-level check is not enough on its own: a failed field
 * refinement leaves zod's status merely "dirty", so object-level `.refine()`
 * rules still run and would pile the same bogus ordering error on top. The
 * schemas using this must also skip their date comparison when either side is
 * unparseable.
 */
export function dateFieldSchema(label: string) {
  return z
    .string()
    .min(1, `${label} is required`)
    .refine((value) => toDateInputValue(value) !== null, {
      message: `${label} must be a valid date`,
    });
}
